<template>
  <v-row class="pa-0 ma-0">
    <v-col v-if="label" cols="12" class="py-0 px-0 ma-0 text-caption">
      &nbsp;
    </v-col>

    <v-col cols="12" class="pt-0 mt-0 pl-0">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="inputText"
            v-bind="attrs"
            v-on="on"
            :label="label"
            dense
            outlined
            hide-details
            :error="inputError"
            :rules="[validateDate]"
            @blur="onBlur"
            @keyup.enter="onBlur"
          />
        </template>

        <v-date-picker
          v-model="pickerDate"
          :max="today"
          @input="onDatePick"
          no-title
          scrollable
        />
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    value: {
      type: String, // Expected format: 'YYYY-MM-DD'
      default: null,
    },
    label: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      menu: false,
      pickerDate: this.value || null,
      inputText: this.value
        ? moment(this.value, 'YYYY-MM-DD').format('DD-MM-YYYY')
        : '',
      inputError: false,
    };
  },
  computed: {
    today() {
      return moment().format('YYYY-MM-DD');
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.pickerDate = newVal;
        this.inputText = moment(newVal, 'YYYY-MM-DD').format('DD-MM-YYYY');
      } else {
        this.pickerDate = null;
        this.inputText = '';
      }
    }
  },
  methods: {
    validateDate(val) {
      const date = moment(val, 'DD-MM-YYYY', true);
      if (!val) return true;
      if (!date.isValid()) {
        this.inputError = true;
        return 'Fecha inválida';
      }
      if (date.isAfter(moment(), 'day')) {
        this.inputError = true;
        return 'No puede ser una fecha futura';
      }
      this.inputError = false;
      return true;
    },
    onBlur() {
      const date = moment(this.inputText, 'DD-MM-YYYY', true);
      if (date.isValid() && date.isSameOrBefore(moment(), 'day')) {
        const formatted = date.format('YYYY-MM-DD');
        this.pickerDate = formatted;
        this.$emit('input', formatted);
      } else {
        this.inputError = true;
      }
    },
    onDatePick(val) {
      this.menu = false;
      this.pickerDate = val;
      this.inputText = moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY');
      this.inputError = false;
      this.$emit('input', val);
    }
  }
};
</script>
